// extracted by mini-css-extract-plugin
module.exports = {"bar":"MenuBar_bar__37R6W"};